import React from "react";
import { Box } from "./style";
import { Link } from "react-router-dom";
const NoMatch = props => {
  return (
    <Box>
      <div className="notfound">
        <div className="notfound-404">
          <h1>404</h1>
        </div>
        <h2>این صفحه یافت نشد</h2>
        <p>متاسفانه صفحه ای که به دنبال آن هستید موجود نمی‌باشد</p>
        <Link to="/">برو به صفحه اصلی</Link>
      </div>
    </Box>
  );
};
export default NoMatch;
